import { TrendingUp, Clock, BarChart3 } from "lucide-react";

const STATS = [
  [TrendingUp, "78%", "Accuracy"],
  [Clock, "4.2h", "Focus Time"],
  [BarChart3, "12", "Concepts Mastered"],
];

export default function LandingParentDashboard() {
  return (
    <section id="parents" className="py-10 sm:py-16 bg-slate-900 text-white border-y border-slate-800" data-testid="landing-parent-section">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-2 gap-10 items-center">
        <div className="order-2 md:order-1 relative pb-6" data-testid="parent-dashboard-visual">
          <img
            src="https://static.prod-images.emergentagent.com/jobs/efb5525d-e484-4894-a0d3-6f8b4f2b6938/images/343c3cdcdb18b915131f0c1019749d737d2d2ca220776c48a1640f114c8deb0f.jpeg"
            alt="Indian mother and daughter viewing SmartGuru parent dashboard"
            className="rounded-3xl shadow-xl w-full object-cover aspect-[4/5]"
          />
          <div className="absolute -bottom-2 left-3 right-3 sm:left-6 sm:right-6 bg-card/95 backdrop-blur border border-border rounded-2xl p-4 shadow-xl" data-testid="parent-dashboard-preview-card">
            <p className="text-[9px] font-bold uppercase tracking-widest text-muted-foreground mb-2">Sample Weekly Summary</p>
            <div className="grid grid-cols-3 gap-2">
              {STATS.map(([Icon, val, label]) => (
                <div key={label} className="text-center">
                  <Icon size={14} className="text-primary mx-auto mb-1" />
                  <p className="font-heading font-bold text-sm">{val}</p>
                  <p className="text-[9px] text-muted-foreground">{label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="order-1 md:order-2">
          <p className="text-xs font-bold uppercase tracking-widest text-indigo-400">For Parents</p>
          <h2 className="font-heading font-bold text-3xl sm:text-4xl mt-2 text-white">See exactly how your child is learning.</h2>
          <p className="text-slate-300 mt-3">No guesswork. The Parent Dashboard shows chapter-by-chapter mastery, accuracy trends, focus time, and what to revisit next — in plain English, not just grades.</p>
        </div>
      </div>
    </section>
  );
}
